


import React from "react";

const BrandSection = () => {
  return (
    <section
      className="brand--layout5 space-top space-extra-bottom"
      style={{
        backgroundImage: "url('/images/bg/bg-5-1.jpg')",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <div className="container">
        <div className="row align-items-center justify-content-center">
          
          {/* FULL CONTENT (NO LOGOS) */}
          <div className="col-lg-10 text-center">
            <div className="white-title2">
              
              <span className="sec-subtitle" style={{ color: "#D8A33A" }}>
                Trusted Mumbai Airport Cab Service
              </span>

              <h2 className="sec-title h1 " style={{ color: "#D8A33A" }}>
                Comfortable & Reliable Mumbai Airport Cabs
              </h2>

              <p className="sec-text" style={{ color: "#e5e5e5" }}>
                Mumbai Airport Cab provides 24/7 airport pickup and drop services,
                ensuring safe, affordable, and comfortable travel for every passenger.
                We specialize in <b>airport transfers, local Mumbai rides, corporate travel,
                and outstation cab services</b> with professional drivers and GPS-enabled vehicles.
              </p>

              <p className="sec-text" style={{ color: "#e5e5e5" }}>
                Whether you are arriving at <b>Chhatrapati Shivaji Maharaj International Airport</b>
                or heading to the airport, we guarantee on-time pickup, clean cars,
                transparent pricing, and hassle-free booking experience.
              </p>

             
              <div className="row mt-4">
  <div className="col-md-3 col-6 mb-3">
    <h5 style={{ color: "#fff" }}>🚖 24x7 Mumbai Airport Cabs</h5>
  </div>

  <div className="col-md-3 col-6 mb-3">
    <h5 style={{ color: "#fff" }}>✈ Affordable Airport Cabs</h5>
  </div>

  <div className="col-md-3 col-6 mb-3">
    <h5 style={{ color: "#fff" }}>🚗 Airport Outstation Cabs</h5>
  </div>

  <div className="col-md-3 col-6 mb-3">
    <h5 style={{ color: "#fff" }}>🛣 All New Vehicles Available</h5>
  </div>
</div>

              {/* Button */}
              <div className="pt-lg-3">
                <a href="/booking" className="vs-btn style5">
                  Book Your Mumbai Airport Cab
                </a>
              </div>

            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default BrandSection;